import axios from 'axios'

let instance: any = {}
instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 50000
})

instance.interceptors.request.use(
  (config: any) => {
    return config
  },
  (error: any) => {
    // Do something with request error
    console.error('error:', error) // for debug
    Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response: any) => {
    return response
  },
  (error: any) => {
    console.error('error:' + error) // for debug
    return Promise.reject(error)
  }
)

export default instance
